<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'contactType', params: {} }">
            Contact Type
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'contactTypeView', params: {} }">
              View Contact Type
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Contact Type
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="contactType.name">
            <td max-width="35%" class="text-subtitle-1">Name:</td>
            <td>{{ contactType.name }}</td>
          </tr>
          
          <tr v-if="contactType.description">
            <td max-width="35%" class="text-subtitle-1">Description:</td>
            <td>{{ contactType.description }}</td>
          </tr>
          
          <tr v-if="contactType.has_student">
            <td max-width="35%" class="text-subtitle-1">Has Student:</td>
            <td>{{ contactType.has_student }}</td>
          </tr>
          
          <tr v-if="contactType.has_teacher">
            <td max-width="35%" class="text-subtitle-1">Has Teacher:</td>
            <td>{{ contactType.has_teacher }}</td>
          </tr>
          
          <tr v-if="contactType.has_ledger">
            <td max-width="35%" class="text-subtitle-1">Has Ledger:</td>
            <td>{{ contactType.has_ledger }}</td>
          </tr>
          
          <tr v-if="contactType.has_appointment">
            <td max-width="35%" class="text-subtitle-1">Has Appointment:</td>
            <td>{{ contactType.has_appointment }}</td>
          </tr>
          
          <tr v-if="contactType.has_note">
            <td max-width="35%" class="text-subtitle-1">Has Notes:</td>
            <td>{{ contactType.has_note }}</td>
          </tr>
          
          <tr v-if="contactType.has_calls">
            <td max-width="35%" class="text-subtitle-1">Has Calls:</td>
            <td>{{ contactType.has_calls }}</td>
          </tr>
          
          <tr v-if="contactType.has_email">
            <td max-width="35%" class="text-subtitle-1">Has Emails:</td>
            <td>{{ contactType.has_email }}</td>
          </tr>
          
          <tr v-if="contactType.has_sms">
            <td max-width="35%" class="text-subtitle-1">Has SMS:</td>
            <td>{{ contactType.has_sms }}</td>
          </tr>
          
          <tr v-if="contactType.has_inquiry">
            <td max-width="35%" class="text-subtitle-1">Has Inquiry:</td>
            <td>{{ contactType.has_inquiry }}</td>
          </tr>
          
          <tr v-if="contactType.has_group">
            <td max-width="35%" class="text-subtitle-1">Has Group:</td>
            <td>{{ contactType.has_group }}</td>
          </tr>
          
          <tr v-if="contactType.has_attachment">
            <td max-width="35%" class="text-subtitle-1">Has Attachment:</td>
            <td>{{ contactType.has_attachment }}</td>
          </tr>
          
          <tr v-if="contactType.has_car">
            <td max-width="35%" class="text-subtitle-1">Has Car:</td>
            <td>{{ contactType.has_car }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getContactType } from "@/services/contactType";
    

    export default {
      data() {
        return {
            id: '',
            contactType: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "contactTypeEdit", params: { id: id }});
        },
        setInstace() {
          this.setDependencies().then( () => {
            getContactType(this.id)
            .then((response) => {
              this.contactType = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading contactType");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstace();
        this.$emit("showParent", false);
      }
    }
    </script>
    